import Axios from 'axios';

export default {
  create(billId, amount, expiryDate, kind) {
    return Axios.post('/admin/discounts', {
      bill_id: billId,
      amount,
      expiry_date: expiryDate,
      kind,
    })
      .then(({ data }) => data);
  },

  disable(discountId) {
    return Axios.put(`/admin/discounts/${discountId}/disable`)
      .then(({ data }) => data);
  },

  enums() {
    return Axios.get('/admin/discounts/enums')
      .then(({ data }) => data);
  },

  get(billId) {
    return Axios.get('/admin/discounts', { bill_id: billId })
      .then(({ data }) => data);
  },

  show(discountId) {
    return Axios.get(`/admin/discounts/${discountId}`)
      .then(({ data }) => data);
  },

  update(discountId, amount, expiryDate) {
    return Axios.put(`/admin/discounts/${discountId}`, {
      amount,
      expiry_date: expiryDate,
    })
      .then(({ data }) => data);
  },
};
